<template>
  <div class="page flex-col">
    <div class="flex-col">
      <div class="group_3 flex-row">
        <span class="text_7" style="cursor: pointer" @click="handleJump('/home')">首页</span>
        <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_8" style="cursor: pointer" @click="handleClick(0, true)">加入我们</span>
        <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_9" style="cursor: pointer" @click="handleClick(0)">企业现状</span>
        <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_10">团队</span>
      </div>
      <div class="group_4 flex-row justify-between">
        <div class="text-wrapper_1 flex-col"><span class="text_11">鼎言智造董事会</span></div>
        <div class="section_1 flex-col">
          <div class="text-wrapper_28 flex-col"><span class="text_38">财务部</span></div>
          <div class="box_2 flex-row">
            <div class="text-wrapper_2 flex-col"><span class="text_12">出纳</span></div>
            <div class="text-wrapper_26 flex-col"><span class="text_36">会计</span></div>
          </div>
          <div class="box_3 flex-row justify-between">
            <div class="text-wrapper_3 flex-col"><span class="text_13">行政部</span></div>
            <div class="block_2 flex-col justify-between">
              <div class="text-wrapper_4 flex-col"><span class="text_14">人事专员</span></div>
              <div class="text-wrapper_5 flex-col"><span class="text_15">培训</span></div>
            </div>
          </div>
          <div class="box_4 flex-row justify-between">
            <div class="text-wrapper_6 flex-col"><span class="text_16">策划部</span></div>
            <div class="box_5 flex-col justify-between">
              <div class="text-wrapper_7 flex-col"><span class="text_17">设计布局</span></div>
              <div class="text-wrapper_8 flex-col"><span class="text_18">信息采集</span></div>
            </div>
          </div>
          <div class="box_6 flex-row">
            <div class="text-wrapper_9 flex-col"><span class="text_19">采购</span></div>
          </div>
          <div class="box_7 flex-row justify-between">
            <div class="text-wrapper_10 flex-col"><span class="text_20">商超部</span></div>
            <div class="group_5 flex-col justify-between">
              <div class="text-wrapper_11 flex-col"><span class="text_21">系统</span></div>
              <div class="text-wrapper_12 flex-col"><span class="text_22">营销运营</span></div>
            </div>
          </div>
          <div class="box_8 flex-row">
            <div class="text-wrapper_13 flex-col"><span class="text_23">招商</span></div>
          </div>
          <div class="box_9 flex-row">
            <div class="text-wrapper_14 flex-col"><span class="text_24">采购</span></div>
          </div>
          <div class="box_10 flex-row justify-between">
            <div class="text-wrapper_15 flex-col"><span class="text_25">团膳部</span></div>
            <div class="section_2 flex-col justify-between">
              <div class="text-wrapper_16 flex-col"><span class="text_26">成本核算</span></div>
              <div class="text-wrapper_17 flex-col"><span class="text_27">运营</span></div>
            </div>
          </div>
          <div class="box_11 flex-row">
            <div class="text-wrapper_18 flex-col"><span class="text_28">安全</span></div>
          </div>
          <div class="box_12 flex-row">
            <div class="text-wrapper_19 flex-col"><span class="text_29">运营</span></div>
          </div>
          <div class="box_13 flex-row justify-between">
            <div class="text-wrapper_20 flex-col"><span class="text_30">商业部</span></div>
            <div class="section_3 flex-col justify-between">
              <div class="text-wrapper_21 flex-col"><span class="text_31">招商</span></div>
              <div class="text-wrapper_22 flex-col"><span class="text_32">合同洽谈</span></div>
            </div>
          </div>
          <div class="box_14 flex-row">
            <div class="text-wrapper_23 flex-col"><span class="text_33">渠道</span></div>
          </div>
          <div class="text-wrapper_29 flex-col"><span class="text_39">工程部</span></div>
          <div class="box_15 flex-row">
            <div class="text-wrapper_24 flex-col"><span class="text_34">装修整改</span></div>
            <div class="text-wrapper_27 flex-col"><span class="text_37">维修维护</span></div>
          </div>
        </div>
        <div class="text-wrapper_25 flex-col"><span class="text_35">对账员</span></div>
      </div>
      <div class="image-text_1 flex-row justify-between" style="cursor: pointer" @click="handleClick(0)">
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="./../../assets/img/return.webp"
        />
        <span class="text-group_1">返回</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleClick(value, top = false) {
      this.$emit('select', value, top);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
